<!-- RootModal.svelte -->
<script lang="ts">
	import { root_modal_state } from "../states/root_modal_state.svelte";
	import RawModal from "./RawModal.svelte";
	import Modal from "./Modal.svelte";
</script>

{#if root_modal_state.is_open && root_modal_state.component}
	{#if root_modal_state.modal_type === "raw"}
		<RawModal
			bind:open={root_modal_state.is_open}
			{...root_modal_state.modal_props}
		>
			<svelte:component
				this={root_modal_state.component}
				{...root_modal_state.props}
			/>
		</RawModal>
	{:else}
		<Modal
			bind:open={root_modal_state.is_open}
			{...root_modal_state.modal_props}
		>
			<svelte:component
				this={root_modal_state.component}
				{...root_modal_state.props}
			/>
		</Modal>
	{/if}
{/if}
